/* global $:true */
import debug from "debug";

import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-address-validation]';
const FORM_WRAPPER_SELECTOR = 'data-form-wrapper-element';
const COUNTRY_CODE_SELECTOR = '[data-country-code]';
const ADDRESS_LINE_0_SELECTOR = '.address-line-0';
const SINGLE_LINE_FIELD_SELECTOR = 'data-single-line-field';
const SINGLE_LINE_FIELDS_SELECTOR = 'data-single-line-fields';
const LIMIT_TO_COUNTRY_ATTR = 'data-limit-to-country';
const PLUGIN_NAME = 'addressValidation';
const MODULE_NAME = 'app.core/modules/address-validation';
const log = debug(MODULE_NAME);

import googleMapsApiPromise from '../../services/google-maps-api';

log('registerd');

class AddressValidation {

    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$parentEl = $(this.$element.attr(FORM_WRAPPER_SELECTOR));
        this.$addressLine0 = this.$parentEl.find(ADDRESS_LINE_0_SELECTOR);
        this.$countryCodeElement = this.$parentEl.find(COUNTRY_CODE_SELECTOR);
        this.isSingleLine = typeof(this.$element.attr(SINGLE_LINE_FIELD_SELECTOR)) !== 'undefined';
		this.singleLineFields = typeof(this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR)) !== 'undefined' ? this.$element.attr(SINGLE_LINE_FIELDS_SELECTOR) : '';
		this.limitToCountry = typeof(this.$element.attr(LIMIT_TO_COUNTRY_ATTR)) !== 'undefined' ? this.$element.attr(LIMIT_TO_COUNTRY_ATTR) == 'true' : false;
        this.initConsoleErrorDetection();
        $( document ).on( 'address-validation-region-change', this.setComponentRestrictions.bind(this));

        log('AddressValidationPlugin', element);
        googleMapsApiPromise.then(
        	(google) => {
            this.google = google;
			this.init();
			this.preventSubmit();
        	});
    }

	preventSubmit () {

		if (this.$element.closest('form').length) {
			log('preventSubmit.enabled [Preventing form submission on ENTER press.]');

			this.$element.on('keypress', (event) => {
				if (event.keyCode === 13) {
					event.preventDefault();
					log('preventSubmit.keypress', event.keyCode);
				}
			});
		}
	}

    initConsoleErrorDetection() {
        var oldError = console.error;
        var module = this;
        // Stops the input field from being disabled if issue with API
        console.error = function (message) {
            if (message.toLowerCase().includes("google maps api error")) {
                module.$element.removeAttr('disabled');
                module.$element.attr('placeholder', '');
                module.$element.removeAttr('style', '');
                module.$element.parent().find('.field-validation-valid').hide();
            }

            oldError.apply(console, arguments);
        };
    }

    init () {
    	var options = {};

    	this.countryCode = this.$countryCodeElement.val();

    	if (this.limitToCountry && this.countryCode.length > 0) {
    		options['componentRestrictions'] = { country: this.countryCode };
    	}
		if (this.singleLineFields.length > 0) {
		  options['types'] = [this.singleLineFields];
		}

		var el = this.$element.attr('id');
		var autocomplete = new this.google.maps.places.Autocomplete(document.getElementById(el), options);

		this.autocomplete = autocomplete;
		autocomplete.addListener('place_changed', this.fillInAddress.bind(this));
		log('init');
	}

	setComponentRestrictions() {
		if (typeof(this.autocomplete) !== 'undefined') {
			this.countryCode = this.$countryCodeElement.val();

	    	if (this.countryCode.length > 0) {
	    		this.autocomplete.setComponentRestrictions({ country: this.countryCode });
	    	}
		}
	}

    fillInAddress() {
        var place = this.autocomplete.getPlace();
        for (var component in this.options.componentForm) {
            var compElement = this.$parentEl.find('.' + component);
            if (typeof(compElement) !== 'undefined' && compElement.length > 0) {
              compElement.val('');
              compElement.attr('disabled', false);
          }
        }

        var addressLine0 = '';
        var addressLine1 = '';
        var premise = '';
        var subpremise = '';
        var route = '';
        var postBox = '';
        var postalTown = '';
        var locality = '';
        var administrative_area_level_2 = '';
        var fullAddress = place.formatted_address;
		var singleLineFields = this.singleLineFields.length > 0 ? this.singleLineFields.split(',') : Array();

        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          var compElement =  this.$parentEl.find('.' + addressType);

          if (addressType == 'post_box') {
            postBox = place.address_components[i][this.options.componentForm['post_box']];
          }
          if (addressType == 'premise') {
            premise = place.address_components[i][this.options.componentForm['premise']];
          }
          if (addressType == 'subpremise') {
            subpremise = place.address_components[i][this.options.componentForm['subpremise']];
          }
          if (addressType == 'street_number') {
            addressLine1 = place.address_components[i][this.options.componentForm['street_number']];
          }
          if (addressType == 'route') {
            route = place.address_components[i][this.options.componentForm['route']];
          }
          if (addressType == 'postal_town') {
            postalTown = place.address_components[i][this.options.componentForm['postal_town']];
          }
          if (addressType == 'administrative_area_level_2') {
            administrative_area_level_2 = place.address_components[i][this.options.componentForm['administrative_area_level_2']];
          }
          if (addressType == 'locality' || addressType =='colloquial_area') {
			locality = place.address_components[i][this.options.componentForm['locality']];
		  }
          if (this.options.componentForm[addressType] && typeof(compElement) !== 'undefined' && compElement.length > 0) {
            var val = place.address_components[i][this.options.componentForm[addressType]];
            compElement.val(val);
          }
        }

        if (locality.length == 0) {
		  locality = postalTown;
		}
		if (locality.length == 0) {
		  locality = administrative_area_level_2;
		}

        var localityEl =  this.$parentEl.find('.locality');
        if (typeof(localityEl) !== 'undefined') {
			localityEl.val(locality);
		}

        var add0 = subpremise.length > 0 ? subpremise + ' ' : '';
        add0.trim();

        var add1 = postBox.length > 0 ? 'PO BOX ' + postBox + ' ' : '';
        add1 += premise.length > 0 ? premise + ' ' : '';
        add1 += addressLine1.length > 0 ? addressLine1 + ' ' : '';
        add1 += route;
        add1.trim();

        if (typeof(this.$addressLine0) !== 'undefined' && this.$addressLine0.length == 0) {
			this.$addressLine0.val(add0);
		}

        if (!this.isSingleLine) {
			this.$element.val(add1);
		}
		$( document ).trigger('address-validation-complete');
    }
}

AddressValidation.DEFAULTS = {
    componentForm:  {
        post_box: 'long_name',
        premise : 'long_name',
        subpremise: 'long_name',
        street_number: 'short_name',
        sublocality_level_1: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'short_name',
        country: 'short_name',
        postal_code: 'short_name',
        postal_town: 'short_name'
    }
};

plugin(PLUGIN_NAME, AddressValidation);

export function exec () {
  $(document).ready(() => {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}



// WEBPACK FOOTER //
// ./client/src/core/modules/address-validation/index.js